var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"bg"},[_c('v-main',[_c('Navbar'),(_vm.notShopMall)?_c('Avatar'):_vm._e(),_c('AvatarSpeech'),_c('v-fade-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }